angular
  .module('common.directives')
  .directive('edgeSpeedingReport', function () {
    return {
      scope: {
        edge: '=',
        eventSearch: '='
      },
      templateUrl: './templates/edgeSpeedingReports.view.html?t=' + webpackHash,
      link: function ($scope, $element, attrs) {},
      controller: 'edgeSpeedingReportsController'
    }
  })
